module.exports = __webpack_public_path__ + "static/assets/d4b3ce804680eb7d58f6accc7436e807.mp3";